import React from 'react';

import {
    ConfigurationProvider
} from '../../../hooks/widgetConfiguration.js';

import {
    useUpdateShellPrimary,
    useUpdateShellSecondary
} from '../../shell/hooks/shellHooks.js';

import {
    AccountListeningListWidget
} from '../components/AccountListeningListWidget.jsx';

function CurationLayout() {

    useUpdateShellPrimary('Account Settings', {
        companySets: {
            disabled: true
        },
        dataFreshness: {
            disabled: false
        },
        timePeriod: RivalIQ.state.timePeriods.getDefinitionByType(RivalIQ.enums.timePeriod.type.NOT_AVAILABLE)
    });

    useUpdateShellSecondary(true, {
        page: RivalIQ.configuration.menus.getConfiguration().ACCOUNT_SETTINGS
    });

    return (
        <AccountListeningListWidget
            instanceId='account-listening'
        />
    );
}


export default function ListeningAccountUsage(props) {

    const defaultProps = {
    };

    const configurationSchema = {
    };

    return (
        <ConfigurationProvider
            defaultProps={defaultProps}
            configurationSchema={configurationSchema}
        >
            <CurationLayout />
        </ConfigurationProvider>
    );
}
